import type { JSX } from "react";
export function TriggerLogPopover({ onClose }: { readonly onClose: () => void }): JSX.Element {
  return (
    <div
      className="absolute bottom-7 right-0 w-64 bg-surface border border-edge rounded-lg shadow-lg p-3 z-50"
      onMouseLeave={onClose}
    >
      <span className="text-xs text-content-tertiary">No recent triggers</span>
    </div>
  );
}
